import Device from '../../../../../constants/deviceSizes';

export default {
  container: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column'
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    minWidth: 400,
    width: '40%',
    [Device.mobile]: {
      minWidth: 0,
      width: '100%'
    }
  },
  actionButtonsContainer: {
    display: 'flex',
    justifyContent: 'flex-start'
  }
};
